import React from "react";
// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Button from "components/CustomButtons/Button.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import headerLinksStyle from "assets/jss/material-dashboard-react/components/headerLinksStyle.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import TextField from "@material-ui/core/TextField";
import CardBody from "components/Card/CardBody.jsx";
import ModalEmpresa from "./ModalEmpresas.jsx";
import ModalPregunta from "components/Generales/ModalPregunta";

// material-ui icons
import Snackbar from "components/Snackbar/Snackbar.jsx";
import ModalCargando from "../../../../components/Generales/ModalCargando";
import Globales from "utils/Globales";
import { Edit, Search, Close } from "@material-ui/icons";
import InputAdornment from "@material-ui/core/InputAdornment";

class CatEmpresas extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      _id: "",
      FiltrarNombres: "",
      ListaEmpresas: [],
      ListaEmpresasTemp: [],
      Empresaseleccionado: {},
      Disabled: false,
      mensaje: "",
      br: false,
      show: false,
      cargando: false,
      colorNotificacion: "success",
      colorTableRow: "white",
      errorIDIdioma: false,
      entroEliminar: false,
      notificacion: false,
      Total: 0,
      TotalSeleccionado: 0,
      InfoEmpresa: "",
      Titulo: "Registrar un nuevo empleado",
    };
    //Variable global para indicar el total de registros que se obtendra de la base de datos
    global.entrar = true;
    //this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.ListaGeneralEmpresas();
  }

  async ListaGeneralEmpresas() {
    this.setState({ cargando: this.state.entroEliminar ? false : true });
    await fetch(Globales.Url + "Catalogos/Empresas/ListarEmpresas", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: Globales.token,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.error) {
          //Error en la respuesta
          this.setState({
            mensaje: data.mensaje,
            colorNotificacion: "danger",
            Activo: 1,
            cargando: false,
            entroEliminar: false,
          });
          this.showNotification();
        } else {
          if (data.ListadeEmpresas.Empresa.length > 1) {
            this.setState({
              ListaEmpresas: data.ListadeEmpresas.Empresa,
              ListaEmpresasTemp: data.ListadeEmpresas.Empresa,
              Activo: 1,
              cargando: false,
              entroEliminar: false,
              FiltrarNombres: "",
            });
          } else {
            let aux = [];
            aux.push(data.ListadeEmpresas.Empresa)
            this.setState({
              ListaEmpresas: aux,
              ListaEmpresasTemp: aux,
              Activo: data.ListadeEmpresas.Empresa.length,
              cargando: false,
              entroEliminar: false,
              FiltrarNombres: "",
            });
          }
        }
      })
      .catch((err) => console.error("El error es", err));
  }

  //Función para obtener el texto de los inputs
  handleChange(e) {
    const { name, value } = e.target;
    if (name === "FiltrarNombres") {
      const Dataorg = this.state.ListaEmpresasTemp;
      if (value) {
        const NuevaData = Dataorg.filter((Empresa) =>
          String(Empresa.RazonSocial)
            .toUpperCase()
            .includes(String(value).toUpperCase())
        );

        if(NuevaData.length === 0){
          this.setState({
            FiltrarNombres: value,
            ListaEmpresas: NuevaData,
            colorNotificacion: "danger",
            mensaje: "No se encontraron coincidencias",
          });
          this.showNotification();
        }
        else{
          this.setState({
            FiltrarNombres: value,
            ListaEmpresas: NuevaData,
          });
        }
        
      } else {
        this.setState({
          FiltrarNombres: "",
          ListaEmpresas: [...Dataorg],
        });
      }
    }
  }

  eventoModalEliminar(e) {
    this.setState({ show: true, Empresaseleccionado: e });
    return;
  }

  eventoModalPregunta = (valor) => {
    if (valor) {
      this.eliminarEmpresa(this.state.Empresaseleccionado);
    } else {
      this.setState({ show: false });
    }
  };

  eliminarEmpresa(id) {
    this.setState({
      cargando: true,
    });
    fetch(Globales.Url + "Catalogos/Empresas/EliminarEmpresa", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: Globales.token,
      },
      body: JSON.stringify({ _id: id }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.error === undefined) {
          //Error al obtener los registros
          this.setState({ colorNotificacion: "danger" });
        } else if (data.error) {
          //Error al obtener los registros
          this.setState({ colorNotificacion: "danger" });
        } else {
          //Obtuvo los registros correctamente
          this.setState({ colorNotificacion: "success" });
        }
        this.setState({
          mensaje: data.mensaje
            ? data.mensaje
            : "Ocurrio un error al intentar realizar está accion.",
          show: false,
          cargando: false,
          entroEliminar: true,
        });
        this.showNotification();
        this.ListaGeneralEmpresas();
      });
  }

  showNotification() {
    var x = [];
    this.setState({ br: true });
    this.setState(x);
    this.alertTimeout = setTimeout(
      function() {
        this.setState({ br: false });
        this.setState(x);
      }.bind(this),
      4000
    );
  }

  eventoModalEmpresa = (mensaje, Color) => {
    this.setState({showAgregar: false})
    //Cambiar valores por default
    if(mensaje !== "esc"){
      this.setState({
        Titulo: "Nueva Empresa",
        mensaje: mensaje,
        NombreEmpresa: "",
        colorNotificacion: Color,
        op: 0,
        entroEliminar: true,
      });
      this.showNotification();
      this.ListaGeneralEmpresas();
    }
  };

  eventoGuardado = (mensaje, Color) => {
    this.setState({showAgregar: false});
    //Cambiar valores por default
    if(mensaje !== "esc"){
      this.setState({
        mensaje: mensaje,
        colorNotificacion: Color,
      });
      this.showNotification();
      this.ListaGeneralEmpresas();
    }
  };

  openModalNuevoEmpresa = () => {
    //Cambiar valores por default
    this.setState({
      showAgregar: true,
      Titulo: "Nueva Empresa",
      NombreEmpresa: "",
      op: 0,
    });
  };

  openModalEditarEmpresa = (e) => {
    //Cambiar valores por default
    this.setState({
      InfoEmpresa: e,
      _id: e._id,
      Titulo: "Modificar Empresa",
      op: 1,
      showAgregar: true,
    });
  };

  render() {
    const { classes } = this.props;
    let agregar;
    if (this.state.cargando == true) {
      agregar = (
        <ModalCargando Cuerpo={"Cargando"} show={this.state.cargando} />
      );
    }
    if (this.state.showAgregar == true) {
      agregar = (
        <ModalEmpresa
          xs={18}
          Titulo={this.state.Titulo}
          InfoEmpresa={this.state.InfoEmpresa}
          showAgregar={this.state.showAgregar}
          eventClick={this.eventoModalEmpresa}
          op={this.state.op}
        />
      );
    }

    return (
      <div>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={10}>
            <Card>
              <CardHeader color="info" text={true}>
                <h4 className={classes.cardTitle}>Filtro</h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <TextField
                      id="FiltrarNombres"
                      style={{ width: "23vw" }}
                      variant="outlined"
                      type="text"
                      size="small"
                      label="Razón social"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Search />
                          </InputAdornment>
                        ),
                        onChange: this.handleChange.bind(this),
                        value: this.state.FiltrarNombres,
                        name: "FiltrarNombres",
                        id: "FiltrarNombres",
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <Button
                      size="sm"
                      type="submit"
                      color="info"
                      round
                      className="pull-right"
                      onClick={() => this.openModalNuevoEmpresa()}
                    >
                      Nuevo
                    </Button>
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
            <Card>
              <CardHeader color="info">
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <h4 className="pull-left">Lista de empresas</h4>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <h4
                      className="pull-right"
                      style={{ marginRight: "15px", marginTop: 0 }}
                    >
                      {this.state.ListaEmpresas.length} Empresa(s)
                    </h4>
                  </GridItem>
                </GridContainer>
              </CardHeader>
              <CardBody>
                <div className="table-responsive text-nowrap table-wrapper-scroll-y">
                  <table className="table table-sm table-hover">
                    <thead>
                      <tr>
                        <th className="center">Razon social</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.ListaEmpresas.map((Empresa, index) => {
                        return (
                          <tr key={Empresa._id + "-" + index}>
                            <td onClick={() =>this.openModalEditarEmpresa(Empresa)} style={{verticalAlign: "middle", cursor: "default"}}>{Empresa.RazonSocial}</td>
                            <td style={{verticalAlign: "middle", cursor: "default"}}>
                            <Button
                                color="danger"
                                round
                                justIcon
                                className="pull-right"
                                size="sm"
                                onClick={() =>
                                  this.eventoModalEliminar(Empresa._id)
                                }
                              >
                                <Close />
                              </Button>
                              <Button
                                color="info"
                                round
                                justIcon
                                className="pull-right mr-2"
                                size="sm"
                                onClick={() =>
                                  this.openModalEditarEmpresa(Empresa)
                                }
                              >
                                <Edit />
                              </Button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        <div id="">
          <ModalPregunta
            Titulo={"Eliminar empresa"}
            Cuerpo={"¿Está seguro de dar de baja la empresa?"}
            show={this.state.show}
            eventClick={this.eventoModalPregunta}
          />
          {agregar}
        </div>
        <div id="">
          <Snackbar
            place="tr"
            color={this.state.colorNotificacion}
            message={this.state.mensaje}
            open={this.state.br}
            closeNotification={() => this.setState({ br: false })}
            close
          />
        </div>
      </div>
    );
  }
}

export default withStyles(headerLinksStyle)(CatEmpresas);
